export const getDeleted = (original: string[], updated: string[]) =>
  original.filter((value) => !updated.includes(value));
